import React from 'react';

import PIcon from '../icons/PIcon/PIcon';
import PButton from './PButton';
import {v4 as uuidv4} from 'uuid';
import '../../styles/colors.scss';

const componentKey = uuidv4();

export const PIconButton = (props: any) => {
  const {
    id,
    onClickAction,
    iconClass,
    buttonType,
    buttonText,
    buttonIcon,
    buttonClass,
    buttonColor,
    buttonStyle,
    buttonShape,
    buttonSize,
    buttonDisable,
    buttonVariant,
    divClassName,
    inline,
  } = props;
  // console.log('Button props are: ', props);
  const onClickFunction: Function = onClickAction ? onClickAction : () => null;
  const cursor = buttonDisable ? 'not-allowed' : 'pointer';
  // console.log('Button disable status is: ', [buttonDisable, cursor]);
  const StyledPButton: React.FC = () => {
    return (
      <PButton
        key={`${componentKey}-button`}
        type={buttonType || 'button'}
        style={buttonStyle || {cursor: cursor}}
        // tag={id}
        id={id}
        disabled={buttonDisable || false}
        className={buttonClass || 'px-4 mx-4'}
        color={buttonColor || 'primary'}
        size={buttonSize || 'sm'}
        shape={buttonShape || 'pill'}
        variant={buttonVariant || ''}
        onClick={(val: any) => onClickFunction(val)}
      >
        {buttonIcon && <PIcon key={`${componentKey}-icon`} name={buttonIcon} className={iconClass || 'mx-2'} />}
        {buttonText}
      </PButton>
    );
  };

  return inline ? (
    <div className={divClassName || 'mt-3 mb-3'}>
      <StyledPButton />
    </div>
  ) : (
    <StyledPButton />
  );
};
export default PIconButton;
